module.exports = __webpack_public_path__ + "img/blue25.87bf7760.png";